var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.002,
    height: 20,
    viewBox: "0 0 24.002 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.06 10.349a4.455 4.455 0 0 0 .922-5.364 4.665 4.665 0 0 0-.922-1.207 5.132 5.132 0 0 0-6.962 0l-1.567 1.478a.782.782 0 0 1-1.06 0L9.9 3.778a4.925 4.925 0 0 0-1.279-.87 5.063 5.063 0 0 0-6.6 2.078 4.459 4.459 0 0 0 .934 5.377L12 19.269zM12 3.754l1.036-.977a6.7 6.7 0 0 1 9.083 0 6.087 6.087 0 0 1 1.2 1.575 5.807 5.807 0 0 1-1.191 6.987l-9.589 9.442a.781.781 0 0 1-1.083 0l-9.573-9.428a5.812 5.812 0 0 1-1.2-7A6.605 6.605 0 0 1 9.3 1.642a6.426 6.426 0 0 1 1.668 1.135z",
    transform: "translate(0 -1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.598af05a.svg";
export { ForwardRef as ReactComponent };